import { gql } from "gql";

export const GET_PARTICIPANTS_SUMMARY = gql(/* GraphQL */ `
  query GetCompanyDocumentParticipantsSummary($id: ID!) {
    getCompanyDocumentById(id: $id) {
      confirmationInfoCount {
        total
        read
        unread
      }
    }
  }
`);
